import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import InterviewFeedbackPage from '../../features/interview/components/InterviewFeedbackPage';

const InterviewFeedbackPageRoute = () => (
  <ProtectedRoute requiresAuth={true}>
    <InterviewFeedbackPage />
  </ProtectedRoute>
);

export default InterviewFeedbackPageRoute;
